import { useEffect, useState } from 'react';
import { publicCatalogApi } from '@/features/publicsite/catalog/api/publicCatalogApi';
import type { Counts } from '@/features/publicsite/types/catalog/Counts';

/**
 * A total for display, or nothing at all while the request is still in flight.
 *
 * Empty rather than zero, and shared rather than written out beside each caller: "0 advisers" is a
 * claim, and a wrong one before the counts arrive. The hero and the closing figures both print
 * totals this way, and the rule is the kind that goes quietly wrong in one copy.
 */
export const totalOrBlank = (counts: Counts | null, n: number | undefined) =>
  counts ? String(n ?? 0) : '';

/** Loads the totals once. Exported so the home page can share one request with this grid. */
export function useCatalogCounts(): Counts | null {
  const [counts, setCounts] = useState<Counts | null>(null);
  useEffect(() => {
    let live = true;
    publicCatalogApi.counts().then((c) => {
      if (live) setCounts(c);
    });
    return () => {
      live = false;
    };
  }, []);
  return counts;
}
